import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ITimetableResponseBody } from './types';

export const getTimetable = async (timetableId: string): Promise<ITimetableResponseBody> => {
  try {
    const res = await fetch(`${API_URL}/timetables/${timetableId}`);

    if (!res.ok) throw new Error(res.statusText);

    return await res.json();
  } catch (e) {
    throw e instanceof Error ? e : new Error(String(e));
  }
};
